import React from 'react';
import { Content, FlexboxGrid } from 'rsuite';
import PortalHeader from '../../components/layout/PortalHeader';
import Success from '../../components/payment/common/success/Success';
import TaxSuccessFields from '../../components/payment/common/success/TaxSuccessFields';
import { FLOWS_ENUM } from '../../common/enums';

const TaxSuccess = () => {
  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader flow={FLOWS_ENUM.PAY_TOT} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={24}>
        <Content>
          <Success successComponent={() => <TaxSuccessFields />} />
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default TaxSuccess;
